import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const ToolbarContainer = styled(Box)(() => ({
    'display': 'flex',
    'justifyContent': 'space-between',
    'alignItems': 'center',
    'padding': '8px',
}));
export const EditFormContainer = styled(Box)(() => ({
    margin: 'auto',
    width: '1200px',
}));

export const FullPageContainer = styled(Box, {shouldForwardProp: (prop) => prop !== 'absolute'})(({absolute}) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    width: '100%',
    height: absolute ? '100vh' : '100%',
    textAlign: 'center',
}));
